import React from 'react';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import useApp from 'hooks/useApp';
import { useTranslation } from 'react-i18next';
const PageNotFound = (props) => {
    
    const app = useApp();
    const { t } = useTranslation();
    const HOME=t("HOME")
    const YOU_DO_NOT_HAVE_THE_NECESARY_PERMISIONS_PLEASE_CONTACT_ADMINS=t("YOU_DO_NOT_HAVE_THE_NECESARY_PERMISIONS_PLEASE_CONTACT_ADMINS")
    return (
        <div className="container">
            <div className="grid flex-column align-items-center card">
                <div className="text-pink-500 font-bold text-5xl">403</div>
                <Avatar size="xlarge" icon="pi pi-lock" className="text-pink-500 bg-pink-100  my-4" />
                <div className="text-900 font-medium text-3xl mb-2">{props.message}</div>
                <div className="text-gray-600">{YOU_DO_NOT_HAVE_THE_NECESARY_PERMISIONS_PLEASE_CONTACT_ADMINS}</div>
                <div className="mt-5 text-center">
                <Button onClick={() => app.navigate('/home')} icon="pi pi-arrow-left" label={HOME} />
                </div>
            </div>
        </div>
    )
}

PageNotFound.defaultProps = {
    message: "Access Denied"
}



export default PageNotFound;